<template>
  <section class="c-featuredSection">
    <div class="main-container">
      <div class="content-container">
        <h2>Featured destinations</h2>
        <div class="c-featuredSection__priceContainer">
          <div
            class="c-featuredSection__price"
            v-for="(item, index) in priceItems"
            :key="index">
            <div class="c-featuredSection__priceImgContainer" :style="{ 'background-image': 'url(' + item.image + ')' }">
            </div>
            <div class="c-featuredSection__priceBottomBlock">
              <p class="c-featuredSection__priceVacations">{{ item.city }} Vacations</p>
              <div class="c-featuredSection__priceTextBlock">
                <div>
                  <p class="c-featuredSection__priceFlightsFrom">flights from</p>
                  <p class="c-featuredSection__priceIncludeTaxes">Round-trip including all taxes</p>
                </div>
                <span>${{ item.value }}</span>
              </div>
            </div>
          </div>
        </div>
        <Button class="button" name="See more destinations" color="blue" :transparent="true"></Button>
      </div>
    </div>
  </section>
</template>

<script>
import Button from '@/components/Button'

export default {
  name: 'FeaturedSection',
  data () {
    return {
      priceItems: [
        {
          image: require('@/assets/london_feature.jpg'),
          city: 'London',
          value: '485'
        },
        {
          image: require('@/assets/ny_feature.jpg'),
          city: 'New York City',
          value: '261'
        },
        {
          image: require('@/assets/paris_feature.jpg'),
          city: 'Paris',
          value: '554'
        },
        {
          image: require('@/assets/shanghai_feature.jpg'),
          city: 'Shanghai',
          value: '1,516'
        },
        {
          image: require('@/assets/sydney_feature.jpg'),
          city: 'Sydney',
          value: '894'
        },
        {
          image: require('@/assets/cairo_feature.jpg'),
          city: 'Cairo',
          value: '1,643'
        }
      ]
    }
  },
  components: {
    Button
  }
}
</script>

<style lang="scss" scoped>
@import "@/scss/variables.scss";

.c-featuredSection {
  .content-container {
    padding: 220px 0 80px 0;
    display: block;
  }

  h2 {
    margin-bottom: $base-margin;
    font-weight: bold;
  }

  &__priceContainer {
    width: 100%;
    display: grid;
    grid-template-columns: calc(33.3% - calc(#{$base-padding} * 2 / 3)) calc(33.3% - calc(#{$base-padding} * 2 / 3)) calc(33.3% - calc(#{$base-padding} * 2 / 3));
    grid-template-rows: auto auto;
    grid-gap: $base-padding $base-padding;
    justify-items: stretch;
  }

  &__price {
    width: 100%;
    height: 100%;
    box-shadow: 0px 2px 4px 0 rgba(0, 0, 0, 0.3);
    cursor: pointer;
    transition: box-shadow 0.2s ease-in-out;
    border-radius: 2px;

    &:hover {
      box-shadow: 0px 6px 12px 0 rgba(0, 0, 0, 0.3);
    }
  }

  &__priceImgContainer {
    border-top-right-radius: 2px;
    border-top-left-radius: 2px;
    height: 275px;
    width: 100%;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
  }

  &__priceBottomBlock {
    display: flex;
    flex-direction: column;
    padding: $base-padding;
    text-align: left;
    background-color: #FFFFFF;
  }

  &__priceTextBlock {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;

    span {
      color: $orange;
      font-size: 36px;
      font-weight: bold;
    }
  }

  &__priceVacations {
    font-size: 20px;
    font-weight: bold;
    color: $blue;
    margin-bottom: $base-margin;
  }

  &__priceFlightsFrom {
    font-size: 16px;
    line-height: 20px;
    font-weight: bold;
    color: $grey;
  }

  &__priceIncludeTaxes {
    font-size: 12px;
    color: $light-grey;
  }

  .button {
    margin-top: 50px;
  }
}

@include tablet {
  .c-featuredSection {
    .content-container {
      padding: 200px 0 55px 0;
    }

    &__priceContainer {
      grid-template-columns: calc(50% - calc(#{$base-padding} / 2)) calc(50% - calc(#{$base-padding} / 2));
      grid-template-rows: auto auto auto;
    }

    &__priceImgContainer {
      height: 225px;
    }

    &__priceBottomBlock {
      span {
        font-size: 30px;
      }
    }
  }
}

@include phone {
  .c-featuredSection {
    .content-container {
      padding: 20px 0 40px 0;
    }

    &__priceContainer {
      grid-template-columns: 100%;
      grid-template-rows: auto auto auto auto auto auto auto auto;
    }

    .button {
      margin-top: 0;
    }

    // &__priceImgContainer {
    //   height: 225px;
    // }

    // &__priceBottomBlock {
    //   span {
    //     font-size: 30px;
    //   }
    // }
  }
}
</style>
